export const dateTimeOptions = {
  weekday: 'long',
  day: 'numeric',
  year: 'numeric',
  month: 'short',
};

export const SCREEN_NAMES = {
  LOGIN: 'Login',
  DASHBOARD: 'Tableau de bord',
  USERMANAGEMENT: 'Gérer les utilisateurs',
  ANNOUNCEMENTMANAGEMENT: 'Gérer les annonces',
  EVENTMANAGEMENT: 'Gérer les évènements',
  SEASONMANAGEMENT: 'Gérer les saisons',
  DOCMANAGEMENT: 'Gérer les documents',
  EQUIPMENTMANAGEMENT: 'Gérer les équipements',
  BAG_DETAILS: 'Détails du sac',
  ASSIGN_EQUIPMENT_TO_BAG: 'Assigner un équipement',
  INVITE: 'Inviter un utilisateur',
  ACCEPT_CHILD_INVITE: 'Accepter l\'invitation',
  PROFILE: 'Profil',
  EVENT: 'Evènement',
  NOTIFICATION_SETTINGS: 'Gérer les notifications',
  NOTIFICATION_SCREEN: 'Notifications',
  STATISTICS: 'Statistiques',
  PRIVACY_POLICY: 'Politique de confidentialité',
  DELETE_ACCOUNT: 'Supprimer mon compte',
  MANAGE_ACCESS_POLICIES: 'Gérer les politiques d\'accès',
  MANAGE_TRANSPORTATIONS: 'Gérer les transports',
  MANAGE_DRIVER_GROUPS: 'Groupes de conducteurs',
  MANAGE_NAS: 'Configuration NAS',
  NAS_SCAN: 'Scanner le NAS',
  MY_NAS_MEDIA: 'Mes médias NAS',
  NAS_BROWSE: 'Parcourir le NAS',
  TRIP: 'Trajet',
  TRIP_TRACKING: 'Suivi du trajet',
  TRIP_PUBLIC_TRACKING: 'Suivi public du trajet',
  GAME_LOBBY: "Jeu de l'Imposteur",
  GAME_WAITING_ROOM: 'Salle d\'attente',
  GAME_ROLE_REVEAL: 'Découvrir son rôle',
  GAME_CLUE_PHASE: 'Phase des indices',
  GAME_DISCUSSION: 'Discussion',
  GAME_VOTING: 'Vote',
  GAME_IMPOSTOR_GUESS: 'Devinette',
  GAME_RESULT: 'Résultat du round',
  GAME_FINAL_SCORE: 'Score final',
};

export const ROLE_NAMES = {
  USER: 'USER',
  COACH: 'COACH',
  SUPERADMIN: 'SUPERADMIN',
};

// Google Play reviewer account: a regular (non-coach) account allowed to open the
// "Mes trajets" screen and trigger the location-disclosure/permission flow from
// there, without needing an assigned trip or elevated role. Not visible/usable by
// any other account.
export const GOOGLE_PLAY_REVIEWER_EMAIL = 'googleplay.tester@local';

export const EVENT_PARTICIPANT_MODE = {
  INDIVIDUAL: 'Individuel',
  TEAM: 'Par équipe',
};

export const STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
};

export const GENDER_TYPE = {
  MAN: 'Masculin',
  WOMAN: 'Féminin',
};

export const LEGAL_GUARDIAN_TYPE = {
  FATHER: 'Père',
  MOTHER: 'Mère',
  OTHER: 'Autre',
};

export const EVENT_TYPE = {
  COMPETITION: 'Competition',
  STAGE: 'Stage',
};

export const EVENT_STATUS = {
  SCHEDULED: 'Planifié',
  OPEN: 'Ouvert',
  LIVE: 'Live',
  CLOSED: 'Cloturé',
};

export const EVENT_LEVEL = {
  INTERNATIONAL: 'International',
  NATIONAL: 'National',
  REGIONAL: 'Regional',
};

export const GRADE = {
  WHITE: 'Blanche',
  YELLOW: 'Jaune',
  ORANGE: 'Orange',
  GREEN: 'Verte',
  BLUE: 'Bleue',
  BROWN: 'Marron',
  BLACK: 'Noire',
};

export const AGE_CATEGORY = {
  miniPoussin: {
    minYear: 4,
    maxYear: 5,
    name: 'Mini poussin',
    weights: {
      woman: [20, 25, 30, 35],
      man: [20, 25, 30, 35, 40],
    },
  },
  poussin: {
    minYear: 6,
    maxYear: 7,
    name: 'Poussin',
    weights: {
      woman: [20, 25, 30, 35, 40],
      man: [20, 25, 30, 35, 40, 45],
    },
  },
  pupille: {
    minYear: 8,
    maxYear: 9,
    name: 'Pupille',
    weights: {
      woman: [25, 30, 35, 40, 45],
      man: [25, 30, 35, 40, 45, 50],
    },
  },
  benjamin: {
    minYear: 10,
    maxYear: 11,
    name: 'Benjamin',
    weights: {
      woman: [30, 35, 40, 45, 50],
      man: [30, 35, 40, 45, 50, 55],
    },
  },
  minime: {
    minYear: 12,
    maxYear: 13,
    name: 'Minime',
    weights: {
      woman: [35, 40, 45, 50, 55],
      man: [35, 40, 45, 50, 55, 60, 65],
    },
  },
  cadet: {
    minYear: 14,
    maxYear: 15,
    name: 'Cadet',
    weights: {
      woman: [47, 54, 61],
      man: [52, 57, 63, 70],
    },
  },
  junior: {
    minYear: 16,
    maxYear: 17,
    name: 'Junior',
    weights: {
      woman: [48, 53, 59, 66],
      man: [55, 61, 68, 76],
    },
  },
  espoir: {
    minYear: 18,
    maxYear: 20,
    name: 'Espoir',
    weights: {
      woman: [50, 55, 61, 68],
      man: [60, 67, 75, 84],
    },
  },
  senior: {
    minYear: 18,
    maxYear: 99,
    name: 'Senior',
    weights: {
      woman: [50, 55, 61, 68],
      man: [60, 67, 75, 84],
    },
  },
  veteran1: {
    minYear: 35,
    maxYear: 45,
    name: 'Vétéran 1',
    weights: {
      woman: [55, 61, 68],
      man: [67, 75, 84],
    },
  },
  veteran2: {
    minYear: 36,
    maxYear: 55,
    name: 'Vétéran 2',
    weights: {
      woman: [55, 61, 68],
      man: [67, 75, 84],
    },
  },
  veteran3: {
    minYear: 56,
    maxYear: 65,
    name: 'Vétéran 3',
    weights: {
      woman: [55, 61, 68],
      man: [67, 75, 84],
    },
  },
  veteran4: {
    minYear: 66,
    maxYear: 99,
    name: 'Vétéran 4',
    weights: {
      woman: [55, 61, 68],
      man: [67, 75, 84],
    },
  },
};
